<template>
	<div id='contra-editar'>
		<h2>Editar contrato</h2>

		<br><br>
		<form v-on:submit.prevent= 'guardarContrato'>
		<table class = "table" align="center">
		  <tbody>
			<tr>
				<td>inquilino </td><td>{{contratos.inquilinoId}}</td>
			</tr>
			<tr>
				<td>propiedad </td><td>{{contratos.propiedadId}}</td>
			</tr>
			<tr>
				<td>inquilino</td><td><input type="text" name="inquilino" disabled style="width:200%" v-model="contratos.inquilino"></td>
			</tr> 
			<tr>
				<td>propiedad</td><td><input type="text" name="propiedad" disabled style="width:200%" v-model="contratos.propiedad"></td>
			</tr>
			<tr>
				<td>nombreComercial</td><td><input type="text" name="nombreComercial" disabled v-model="contratos.nombreComercial"></td>
			</tr>
			
			<tr>
				<td>giro</td><td><input type="text" name="giro" disabled v-model="contratos.giro"></td>
			</tr>
			<tr>
				<td>familia</td><td><input type="text" name="famila" disabled v-model="contratos.familia"></td>
			</tr>
			<tr>
				<td>inicio contrato</td><td>{{formateaFecha(contratos.fechaInicio )}}</td>
			</tr>			

			<tr>
				<td>importe Mes</td><td><input type="number" name="importeMes" min = "100" required v-model="contratos.importeMes"></td>
			</tr>
            <tr>
                <td>depositar A</td><td><input type="text" name="depositarA" min = "100" v-model="contratos.depositarA"></td>
            </tr>            
			<tr v-if="contratos.status != 'PRE-CONTRATO'">
				<td>Status</td>
					<td>
						<select id="status" required v-model="contratos.status" >
							<option value="RENTADO">RENTADO</option>
	  						<option value="FINALIZADO">FINALIZADO</option>
	  						<option value="EN JURIDICO">EN JURIDICO</option>
						</select>{{contratos.status}}
					</td>
			</tr>
			<tr v-if="contratos.status == 'FINALIZADO'">
				<td>Finalizo</td>
				<td>

                    <input type="date" name="fin" v-model="contratos.finalizo">{{formateaFecha(contratos.finalizo)}}</td>

				</td>
			</tr>
		  </tbody>
		</table>
		<br>
		<input type="submit" name="guardaContrato" value="Enviar">
		<br>
		<br>
		</form>
	</div>


</template>

<script>
	import axios from 'axios';
	export default{
			name:'editar-contrato',
            props:['vector', 'cualContrato'],

			mounted(){
				var con= ''; 
				var contratos2= '';

                // checa si tiene autorizacion
                if(!this.vector.includes('MASTERGGUV')){
                    if(!this.vector.includes('Contratos Editar')){
                        document.getElementById('contra-editar').hidden = true;
                        alert('Seccion no autorizada');
                        return;
                    }
                }


				this.id=this.$route.params.id;
                this.id=this.cualContrato;

				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id='+this.id)
  		             .then((respue) => {
  		     			con = respue.data;  		     			

    					contratos2 = con[0]; 

						this.contratos.id = contratos2.id;
						this.contratos.inquilinoId = contratos2.inquilinoId;
						this.contratos.propiedadId = contratos2.propiedadId;
						this.contratos.inquilino = contratos2.inquilino;
						this.contratos.propiedad = contratos2.propiedad;
						this.contratos.nombreComercial = contratos2.nombreComercial;
						this.contratos.giro = contratos2.giro;
						this.contratos.importeMes = contratos2.importeMes;
						this.contratos.familia = contratos2.familia;

						this.contratos.fechaModificacion = contratos2.fechaModificacion;
						this.contratos.quienModifico = contratos2.quienModifico;
						this.contratos.fechaInicio = contratos2.fechaInicio;
						this.contratos.fechaTerminacion = contratos2.fechaTerminacion;
						this.contratos.status = contratos2.status; 
						this.contratos.finalizo = contratos2.finalizo; 
                        this.contratos.depositarA = contratos2.depositarA; 

						if (this.contratos.status == "FINALIZADO"){
							document.getElementById('status').style.display = "none";
							document.getElementById('fechaFinalizo').disabled = "true";
						}

  			 		 });
			},
			data(){
				return {
					id: null,
					contratos:{
						id:'',
						inquilinoId:'',
						propiedadId:'',
						inquilino:'',
						propiedad:'',
						nombreComercial:'',
						giro:'',
						importeMes:'',
						fechaModificacion:'',
						quienModifico:'',
                        depositarA:'',
						status:''
					}
				};
			},
			methods:{
				guardarContrato(){
					var contratos3 = this.contratos;
					var router= this.$router;

					if(contratos3.status == "FINALIZADO"){
						if(!contratos3.finalizo){
							alert("\n\nEn cual fecha finalizo ?");
							return;
						}
						if(confirm("Cuidado\nya no se cargarán las rentas mensuales\npara este contrato a partir del " + this.formateaFecha(contratos3.finalizo) + "\n\nestá de acuerdo ?"))
						{
							// sigue adelante 
						} else return;

					}

					axios.post('https://www.directodo.com/Rentus/accesosdb/modificaContrato.php?id='+contratos3.id+'&inquilinoId='+contratos3.inquilinoId+'&propiedadId='+contratos3.propiedadId+'&inquilino='+contratos3.inquilino+'&propiedad='+contratos3.propiedad+'&nombreComercial='+contratos3.nombreComercial+'&giro='+contratos3.giro+'&importeMes='+contratos3.importeMes+'&fechaModificacion='+contratos3.fechaModificacion+'&quienModifico='+contratos3.quienModifico+'&finalizo='+contratos3.finalizo+'&depA='+contratos3.depositarA+'&status='+contratos3.status)
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
                                    alert('Modificado')
		  		          			//router.push('/con')
                                    this.$emit('cerrar')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
		  		          
				},

				formateaFecha: function (fecha) {
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				}

			}
	}
</script>


// WEBPACK FOOTER //
// src/Contrato-editar.vue